import React, { type PropsWithChildren, type MouseEventHandler } from "react";
import { VisibilityOnIcon } from "@vector-im/compound-design-tokens/assets/web/icons";

interface IProps {
    onClick: MouseEventHandler<HTMLButtonElement>;
}

export const HiddenMediaPlaceholder: React.FunctionComponent<PropsWithChildren<IProps>> = ({ onClick, children }) => {
    return (
        <button onClick={onClick} className="mx_HiddenMediaPlaceholder">
            <div>
                <VisibilityOnIcon />
                <span>{children}</span>
            </div>
        </button>
    );
};
